import request from '@/utils/request'

// 运行里程
export function runMileage(pv, type) {
    return request({
        url: '/screen/runMileage?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 场景分析
export function robotStatisticsNum(pv, type) {
    return request({
        url: '/screen/robotStatisticsNum?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 机器人巡检次数
export function robotSiteNum(pv, type) {
    return request({
        url: '/screen/robotSiteNum?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 各类事件完成率
export function eventFinish(pv, type) {
    return request({
        url: '/screen/eventFinish?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 地图上机器人数量
export function routeRobotNum(pv, type) {
    return request({
        url: '/screen/routeRobotNum?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 运行时长
export function intervalRunTime(pv, type) {
    return request({
        url: '/screen/intervalRunTime?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 事件类型
export function eventChart(pv, type) {
    return request({
        url: '/screen/eventChartNew?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 地图上事件
export function mapEventChart(pv, type) {
    return request({
        url: '/screen/mapEventChartNew?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 预计增加工作时长
export function robotWorkingHours(pv, type) {
    return request({
        url: '/screen/robotWorkingHours?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 预计节约成本
export function robotWorkingCost(pv, type) {
    return request({
        url: '/screen/robotWorkingCost?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 机器人运行里程统计
export function robotRunMileageStatistics(pv, type) {
    return request({
        url: '/screen/robotRunMileageStatistics?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 机器人值班统计
export function robotDutyStatistics(pv, type) {
    return request({
        url: '/screen/robotDutyStatistics?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}

// 租户名称
export function tenantInfoName(pv) {
    return request({
        url: '/screen/tenantInfoName?tenantInfoId=' + pv.replaceAll("\"", ""),
        method: 'get'
    })
}

// 深圳客户新增
// 环境信息
export function environLineChart(pv, type) {
    return request({
        url: '/szScreen/environLineChart?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}
// 事件分类统计
export function eventTypeChart(pv, type) {
    return request({
        url: '/szScreen/eventTypeChart?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}
// 事件完成百分比统计
export function eventFinishBarChart(pv, type) {
    return request({
        url: '/szScreen/eventFinishBarChart?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}
// 运行里程
export function runTimeMileage(pv, type) {
    return request({
        url: '/szScreen/runTimeMileage?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}
// 语音播放统计
export function voiceChart(pv, type) {
    return request({
        url: '/szScreen/voiceChart?tenantInfoId=' + pv.replaceAll("\"", "") + '&type=' + type,
        method: 'get'
    })
}
// 当日事件完成率
export function todayEventFinish(pv) {
    return request({
        url: '/szScreen/todayEventFinish?tenantInfoId=' + pv.replaceAll("\"", ""),
        method: 'get'
    })
}
// 语音列表
export function robotVoiceList(pv) {
    return request({
        url: '/szScreen/robotVoiceList?tenantInfoId=' + pv.replaceAll("\"", ""),
        method: 'get'
    })
}
// 当日最新环境信息
export function environInfo(pv) {
    return request({
        url: '/szScreen/environInfo?tenantInfoId=' + pv.replaceAll("\"", ""),
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/customIndex.js